import { useEffect, useState } from 'react';
import * as BrandsApi from '../api/Brands';
import { BrandProps } from '../api/Brands';

export const useBrands = () => {
  const [showNew, setShowNew] = useState(false);
  const [brands, setBrands] = useState<BrandProps[]>([]);

  const fetchBrands = async () => {
    const result = await BrandsApi.getAll();
    setBrands(result.sort((a, b) => (a.name > b.name ? 1 : -1)));
  };

  const createBrand = async (props: BrandProps) => {
    try {
      const result = await BrandsApi.create(props);
      setBrands([result, ...brands].sort((a, b) => (a.name > b.name ? 1 : -1)));
      setShowNew(false);
      return result;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Ошибка при создании бренда';
      throw new Error(errorMessage);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  return {
    brands,
    createBrand,
    showNew,
    setShowNew,
    fetchBrands,
  };
};
